import {
  fetchContactIds,
  fetchContactsForADayFn,
  fetchContactsForAYearFn,
  fetchContactsOverview,
  fetchStreamMessagesFn,
  fetchYearsWithContactsFn,
} from './contacts'

const contactsApi = {
  getContactsOverview: {
    key: 'FETCH_CONTACTS_OVERVIEW',
    fn: fetchContactsOverview,
  },
  getStreamMessages: {
    key: 'FETCH_STREAM_MESSAGES',
    fn: fetchStreamMessagesFn,
  },
  getContactYears: {
    key: 'GET_CONTACT_YEARS',
    fn: fetchYearsWithContactsFn,
  },
  getContactsForAYear: {
    key: 'GET_CONTACTS_FOR_A_YEAR',
    fn: fetchContactsForAYearFn,
  },
  getContactsForADay: {
    key: 'GET_CONTACTS_FOR_A_DAY',
    fn: fetchContactsForADayFn,
  },
  getContactIds: {
    key: 'GET_CONTACT_IDS',
    fn: fetchContactIds,
  },
}

export default contactsApi
